/* eslint-disable arrow-body-style, no-shadow */

import _ from "lodash";
import moment from 'moment';

const isPhoneNumEqual = num => value => {
  value = value.replace(/[^\d]/g, "");
  if (value && value.length !== num) {
    return `Phone number must be ${num} digits long`;
  }

  return undefined;
};

const isNumEqual = (num, message) => value => {
  if (!value) {
    return undefined
  }

  value = value.replace(/[^\d]/g, "");
  if (value && value.length !== num) {
    return message;
  }

  return undefined;
};

const isLessThan = (num, message) => value => {
  if (value && value.length >= num) {
    return message;
  }

  return undefined;
};

// Production rejects customers older than 100. Sandbox / development only
// reject obviously wrong years so provider test profiles (e.g. DOB in 1922)
// can be entered.
const MAX_AGE_YEARS = 100;
const MIN_BIRTH_YEAR = 1900;
const isProductionEnv = process.env.REACT_APP_PAYPAIR_ENV === 'production';

export const validate = values => {
  const errors = {}
  const date = `${values.year}-${values.month}-${values.day}`
  const currentDate = moment(new Date(), "YYYY.MM.DD")
  const dateOfBirth = moment(date, "YYYY.MM.DD");
  const diff = moment.duration(currentDate.diff(dateOfBirth)).asYears();
  if (diff <= 18) {
    errors.year = 'You should be older'
  }
  const yearIsIncorrect = isProductionEnv
    ? diff >= MAX_AGE_YEARS
    : dateOfBirth.year() < MIN_BIRTH_YEAR
  if (yearIsIncorrect) {
    errors.year = 'Year is incorrect'
  }
  return errors
}

export const required = value =>
  value || typeof value === "number" ? undefined : "required";

export const isPhoneNumEqual10 = isPhoneNumEqual(10);

export const isYearEqual4 = isNumEqual(4, "Year should be 4 digits long");

export const isCodeEqual6 = isNumEqual(6, "Code should be 6 digits long");

export const isNumEqual4 = isNumEqual(4, "Must be 4 digits long");

export const isNumEqual9 = isNumEqual(9, "Number must be 9 digits long");
export const isCardBinComplete = isNumEqual(6, "Enter all 6 digits");

export const isNumEqual14 = isNumEqual(14, "Number must be 9 digits long");

export const isLessThan20digits = isLessThan(
  20,
  "Should not exceed 20 digits long."
);

export const isLessThan20characters = isLessThan(
  20,
  "Should not exceed 20 characters long."
);

// US checking account numbers: 4 to 17 digits
export const isBankAccountNumber = value => {
  if (!value) {
    return undefined;
  }

  const digits = value.replace(/[^\d]/g, "");
  if (digits.length < 4 || digits.length > 17) {
    return "Must be 4 to 17 digits long";
  }

  return undefined;
};

export const onlyNumber = value => {
  // value = value.replace(/[^\d]/g, "");
  if (value && isNaN(Number(value))) {
    return "Must be a number";
  }
  return undefined;
};

export const onlyPositiveInteger = value => {
  value = value && Number(value) ? Number(value) : null;

  if (_.isNull(value) || !Number.isInteger(value) || value <= 0) {
    return "only positive";
  }

  return undefined;
};

export const greaterOrEqualZero = value => {
  if (!value) {
    return undefined;
  }
  if (value >= 0) {
    return undefined;
  }

  return "only numbers";
};

export const greaterOrEqualZeroIncome = value => {
  value = value.replace(/[$]/g, "");

  if (!Number(value)) {
    return undefined;
  }
  if (Number(value) >= 0) {
    return undefined;
  }
  return "only numbers";
};

const isNumGreaterThan = (num, message) => value => {
  if (!value) {
    return undefined
  }

  value =  value.replace(/[^0-9 ]/g, "")

  if (value && Number(value) > num) {
    return message;
  }

  return undefined;
};

export const isNumGreaterThan50000 = isNumGreaterThan(50000, "Max amount is $50,000");


export const onlyNumberAndLetters = value => {
  const rexExp = /^[a-zA-Z0-9]+$/;

  if (value && !rexExp.test(value)) {
    return "Can be letters and digits";
  }

  return undefined;
};

export const accountNumMustMatch = (value, allValues) => {
  return value !== allValues.accountNum ? 'Account numbers do not match' : undefined;
};

export const validateEmail = (email) => {
  const emailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  if (email && !emailRegExp.test(email)) {
    return "Valid Email Address is required.";
  }

  return undefined;
};

const maxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

const minLength = min => value =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined;

export const maxLength15 = maxLength(15);
export const minLength2 = minLength(2);
export const maxLength4 = maxLength(4);
export const minLength3 = minLength(3);

export const isNumber = value => value && isNaN(Number(value)) ? "Must be a number" : undefined;

export const validateCreditCard = value =>
  value && !/^\d{16}$/.test(value.replace(/\s/g, "")) ? "Invalid credit card number, must be 16 digits" : undefined;

export const validateExpDate = value =>
  value && !/^(0[1-9]|1[0-2])\/?([0-9]{2})$/.test(value) ? "Invalid date, format MM/YY" : undefined;

export const validateCVV = value =>
  value && !/^\d{3,4}$/.test(value) ? "Invalid CVV, must be 3 or 4 digits" : undefined;

const ONLINE_ONLY_BANK_ROUTING_NUMBERS = [
  '026014928',
  '031101169',
  '031101279',
  '051405515',
  '063115194',
  '065402892',
  '071922476',
  '073972181',
  '101019084',
  '101089742',
  '122287675',
  '124071889',
  '124303120',
  '124303162',
  '264174241',
  '291471024',
  '103100195',
  '041215663',
  '124303201',
  '083009060',
  '265377811',
  '121000248',
  '071004200',
  '211370150',
  '113024588',
  '084003997',
  '264171241',
  '091302966',
  '114924742',
  '122244184'
];

const ONLINE_ONLY_BANK_MESSAGE = 'It looks like this is a routing number for an online-only bank. Please enter a routing number for a traditional bank account (like a credit union, regional, or national bank) to continue.';

export const notOnlineOnlyBankRouting = (value, allValues, props) => {
  if (props && props.providerName === 'progressive' && ONLINE_ONLY_BANK_ROUTING_NUMBERS.includes(value)) {
    return ONLINE_ONLY_BANK_MESSAGE;
  }

  return undefined;
};
